import { api } from '@/store/api'
import { ALL_LIST_TAGS } from '@/features/instructions/instructionsApi.tags'
import type { AccessType } from '@/features/instructions/types'
import type { ModerationState, VisibilityChange } from './types'
import { toVisibilityChange, withRetryAfter } from './lib/reviewResponse'

// Свой тег, не `Moderation`: id статьи и id курса живут в разных пространствах,
// общий тег перечитывал бы модерацию курса с тем же числом.
const draftTags = (_r: unknown, _e: unknown, id: number) =>
  [
    { type: 'ArticleModeration', id },
    { type: 'Instruction', id },
  ] as const

export const articleModerationApi = api.injectEndpoints({
  endpoints: (build) => ({
    getArticleModeration: build.query<ModerationState, number>({
      query: (id) => `instructions/${id}/moderation`,
      providesTags: (_r, _e, id) => [{ type: 'ArticleModeration', id }],
    }),
    setArticleVisibility: build.mutation<VisibilityChange, { id: number; accessType: AccessType }>({
      query: ({ id, accessType }) => ({
        url: `instructions/${id}/visibility`,
        method: 'PATCH',
        body: { accessType },
      }),
      transformResponse: toVisibilityChange,
      transformErrorResponse: withRetryAfter,
      invalidatesTags: (_r, _e, { id }) => [
        { type: 'ArticleModeration', id },
        { type: 'Instruction', id },
        ...ALL_LIST_TAGS,
      ],
    }),
    // 202 — черновик ушёл на проверку, 200 — в нём были только поля без проверки.
    submitArticleUpdate: build.mutation<VisibilityChange, number>({
      query: (id) => ({ url: `instructions/${id}/submit-update`, method: 'POST' }),
      transformResponse: toVisibilityChange,
      transformErrorResponse: withRetryAfter,
      invalidatesTags: draftTags,
    }),
    discardArticleDraft: build.mutation<void, number>({
      query: (id) => ({ url: `instructions/${id}/draft`, method: 'DELETE' }),
      invalidatesTags: draftTags,
    }),
  }),
})

export const {
  useGetArticleModerationQuery,
  useSetArticleVisibilityMutation,
  useSubmitArticleUpdateMutation,
  useDiscardArticleDraftMutation,
} = articleModerationApi
